import * as IoC from 'typescript-ioc';
import { RuntimeConfiguration } from '../implementations/runtime-configuration';
import { OEConnectEnvironment } from '../runtime-configuration';

enum KnovioEnvironment { Dev = 'dev-', Stage = 'stage-', Prod = '' }

/* Get Knovio domain prefix based on provided environment (current as default) */
export const getKnovioEnvPrefix = (env: string = IoC.Container.get(RuntimeConfiguration).getEnv()): string | void => {
    switch (env) {
        case OEConnectEnvironment.Dev:
            return KnovioEnvironment.Dev;

        case OEConnectEnvironment.Stage:
            return KnovioEnvironment.Stage;

        case OEConnectEnvironment.Prod:
            return KnovioEnvironment.Prod;

        default:
            return;
    }
};

export const getKvContentUrl = (): string => `https://view.${getKnovioEnvPrefix()}knowledgevision.com`;
export const getKnovioPresentationUrl = (): string => `${getKvContentUrl()}/presentation/`;

export const getKnovioPresentationUrlById = (presentationId: string): string => presentationId ? `${getKnovioPresentationUrl()}${presentationId}` : '';

export const getKvCentralLoginUrl = (): string => `https://login.${getKnovioEnvPrefix()}kvcentral.com`;
export const getOneclickStartLivestreamUrl = (): string => `${getKvCentralLoginUrl()}/#oneclick/presentation/`;

export const getOneclickStartLivestreamLinkById = (embedCodeId: string): string =>
    embedCodeId ? `${getOneclickStartLivestreamUrl()}${embedCodeId}` : '';

export const cryptPodiumEmbedCode = (value: string, unencoded: string): string => {
    const textToChars = (text): number[] => text.split('').map(c => c.charCodeAt(0));
    const byteHex = (n): string => ('0' + Number(n).toString(16)).substr(-2);
    const applyValueToChar = (code): number => textToChars(value).reduce((a, b) => a ^ b, code);

    return unencoded
        .split('')
        .map(textToChars)
        .map(applyValueToChar)
        .map(byteHex)
        .join('');
};

export const generatePodiumEmbedCode = (presenterLink: string, accessCode: string): string => {
    const regExp = new RegExp('([^\\/]+$)', 'g');
    const result = regExp.exec(presenterLink);

    if (result) {
        const hash = cryptPodiumEmbedCode(result[0], `${accessCode}/`);
        return `${presenterLink}#${hash}`;
    } else {
        return presenterLink;
    }
};

export const getKvThumbnailUrl = (embedId = '', icon = true): string => `${getKvContentUrl()}/thumbnail/${embedId}?play_icon=${icon}`;

export const getKvContentKnovioUrl = (embedId = ''): string => `${getKvContentUrl()}/presentation/${embedId}`;